/**
 * ViewTag locator for `css_selector`
 * @module
 */
var DocumentEnv = require('core/env/document');
var nodeNames = require('core/tags/enums').nodeNames;
var parseValueType = require('core/tags/parse_value_type');

/**
 * @param {ViewTag} viewTag
 * @return {*}
 */
module.exports = function(viewTag:ViewTag): any {
  var selector = viewTag.locator;

  var matchedElements = DocumentEnv.querySelectorAll(<string>selector);
  var value;

  if (matchedElements.length > 0) {
    var matchedElement = matchedElements[0];
    switch (matchedElement.nodeName) {
      case nodeNames.INPUT:
        value = (<HTMLInputElement>matchedElement).value.trim();
        break;
      case nodeNames.SELECT:
        value = (<HTMLSelectElement>matchedElement).value.trim();
        break;
      default:
        var textValue = (<HTMLElement>matchedElements[0]).innerText || matchedElements[0].textContent;
        value = textValue.trim().replace(/\s+/g, ' ');
    }
  }

  return parseValueType(viewTag.valueType, value);
};
